export const RESERVATION_URL =
  "https://reservation.asiwebres.com/v5/RoomAvailability.aspx?id=07c7500a846240298e027aedcc71fa51&lang=en&Curr=1";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_0eab4c7f-6e15-47fa-b0e0-619340f56efd/artifacts/sinu4mcv_Small%20logo.png";

export const OFFICIAL_LOGO_URL = "/images/property/wb-logo.png";

export const PROPERTY = {
  name: "Westbridge Inn & Suites",
  street: "1408 N US-65",
  cityState: "Carrollton, MO 64633",
  phone: "(660) 542-2988",
  office: "(660) 542-2988",
  email: "carrollton@westbridgehotelgroup.com",
  roomCount: 34,
  checkIn: "3:00 PM",
  checkOut: "11:00 AM",
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6258.83!2d-93.4969!3d39.3624!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDIxJzQ0LjYiTiA5M8KwMjknNDguOCJX!5e0!3m2!1sen!2sus!4v1700000000000",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/accommodations", label: "Rooms" },
  { to: "/gallery", label: "Gallery" },
  { to: "/local-guide", label: "Local Guide" },
  { to: "/blog", label: "Journal" },
  { to: "/amenities", label: "Amenities" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export const HERO_IMAGES = [
  "/images/property/exterior-main.jpg",
  "/images/property/king-room-wide.jpg",
  "/images/property/king-room-front.jpg",
];
